/**
 * i18n 模板插值工具（方案 B）
 * - 使用 `{key}` 作为占位符
 * - 未提供的 key 保持原样
 */
export function formatI18n(template, params = {}) {
    const str = template != null ? String(template) : '';
    const map = params && typeof params === 'object' ? params : {};
    return str.replace(/\{(\w+)\}/g, (m, k) => {
        if (Object.prototype.hasOwnProperty.call(map, k)) {
            return map[k] == null ? '' : String(map[k]);
        }
        return m;
    });
}


